import { calculateWidthFromColumns, generateClassName } from '@klv/shared/utils/functions';
import NewsFeed from '../news-feed';
import TestimonialsQuote from '../testimonials-quote';

import * as s from './styles/testimonialsTwoColumn.module.scss';

import type { ITestimonialsTwoColumn } from './types';

const TestimonialsTwoColumn = ({
  backgroundColor, buttons, categoryLink, posts, quoteText = '', attributionLine,
}: ITestimonialsTwoColumn) => (
  <div
    className={generateClassName([
      s.container,
      s[backgroundColor],
      "defaultPaddingTop",
      "defaultPaddingBottom"
    ])}
    style={{
      '--text-wrapper-padding-left-s576': calculateWidthFromColumns(1.2, 13).slice(0, -1),
      '--text-wrapper-padding-left-s1024': calculateWidthFromColumns(1.2, 8).slice(0, -1),
      '--text-wrapper-padding-left-1200': calculateWidthFromColumns(1, 8).slice(0, -1),
    } as React.CSSProperties}
  >
    <div className="grid">
      <TestimonialsQuote
        className={s.testimonialsTwoColumn}
        classNames={{
          textWrapper: s.testimonialsQuoteTextWrapper,
          quoteIcon: s.testimonialsQuoteIcon,
        }}
        backgroundColor={backgroundColor}
        buttons={buttons}
        quoteText={quoteText}
        attributionLine={attributionLine}
      />
      <NewsFeed
        backgroundColor={backgroundColor}
        categoryLink={categoryLink}
        posts={posts}
      />
    </div>
  </div>
);

export default TestimonialsTwoColumn;
